import { Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Wrapper, IconWrapper, Title, Description, Actions } from './styled'

interface IProps {
  title: string
  description?: string
  icon: IconProp
  iconBadge?: IconProp
  iconBadgeBackground?: string
  iconSize?: 'large' | 'normal' | 'small'
  iconBackground?: string
  iconColor?: string
  action?: () => void
  actionIcon?: IconProp
  actionTitle?: string
  actionBackground?: boolean
  actionDisabled?: boolean
  titleColor?: string
  descriptionColor?: string
  titleFontSize?: string
  descriptionFontSize?: string
  actionBackgroundColor?: string
  actionTitleColor?: string
  padding?: string
  background?: string
  boxShadow?: boolean
  secondaryAction?: () => void
  secondaryActionIcon?: IconProp
  secondaryActionTitle?: string
}

const EmptyState = ({
  title,
  description,
  icon,
  iconBadge,
  iconBadgeBackground = '#F5222D',
  iconSize = 'normal',
  iconBackground = '#f0f0f0',
  iconColor = '#757575',
  action,
  actionIcon,
  actionTitle,
  actionBackground = true,
  actionDisabled = false,
  titleColor = '#757575',
  descriptionColor = '#757575',
  titleFontSize = '14px',
  descriptionFontSize = '14px',
  actionBackgroundColor = '#e7f3fe',
  actionTitleColor = '#0085FF',
  padding = '24px',
  background = 'transparent',
  boxShadow = false,
  secondaryAction,
  secondaryActionIcon,
  secondaryActionTitle,
}: IProps) => {
  return (
    <Wrapper
      actionBackground={actionBackground}
      actionBackgroundColor={actionBackgroundColor}
      actionTitleColor={actionTitleColor}
      padding={padding}
      background={background}
      boxShadow={boxShadow}
    >
      <IconWrapper
        iconBackground={iconBackground}
        iconColor={iconColor}
        iconSize={iconSize}
        iconBadgeBackground={iconBadgeBackground}
      >
        <FontAwesomeIcon icon={icon} />
        {iconBadge && (
          <span>
            <FontAwesomeIcon icon={iconBadge} />
          </span>
        )}
      </IconWrapper>
      <Title
        color={titleColor}
        fontSize={titleFontSize}
        fontWeight={description ? 'bold' : 'normal'}
      >
        {title}
      </Title>
      {description && (
        <Description color={descriptionColor} fontSize={descriptionFontSize}>
          {description}
        </Description>
      )}
      <Actions actionTitleColor={actionTitleColor}>
        {secondaryActionTitle && (
          <Button onClick={secondaryAction}>
            {secondaryActionIcon && (
              <FontAwesomeIcon icon={secondaryActionIcon} />
            )}
            {secondaryActionTitle}
          </Button>
        )}
        {actionTitle && (
          <Button onClick={action} disabled={actionDisabled}>
            {actionIcon && <FontAwesomeIcon icon={actionIcon} />}
            {actionTitle}
          </Button>
        )}
      </Actions>
    </Wrapper>
  )
}

export default EmptyState
